import { MDTReportStatus } from "../types";
import api from "./api";

export interface CreateMDTReportPayload {
  patient_id: string;
  created_by: number | undefined;
  clinical_note_ids: number[];
  imaging_report_ids: number[];
  histology_report_ids: number[];
}

export interface CreateMDTReportResponse {
  id: number;
  case_id: number | null;
  status: MDTReportStatus;
  ai_response: any;
  patientName: string | null;
}

export const createMDTReport = async (
  payload: CreateMDTReportPayload
): Promise<CreateMDTReportResponse> => {
  try {
    const response = await api.post("/mdtreport", payload, {
      timeout: 120000,
    });
    return response.data.data;
  } catch (error: any) {
    // Normalise client-side timeout so the UI can show a clear message
    if (error?.code === "ECONNABORTED" || /timeout of \d+ms exceeded/i.test(error?.message || "")) {
      throw new Error("MDT report generation timed out. Please try again.");
    }
    throw error;
  }
};

export const getAllMDTReports = async () => {
  const response = await api.get(`/mdtreport`);
  return response.data.data;
};

export const getMDTReportsByPatient = async (patientId: any) => {
  const  response  = await api.get(`/mdtreport/patient/${patientId}`);
  return response.data.data;
};

export const getMDTReportsById = async (id: any) => {
  const response = await api.get(`/mdtreport/${id}`);
  return response.data.data;
};

export const getApprovedMdtsForDashboard = async () => {
  const res = await api.get("/mdtreport/approved/dashboard");
  return res.data;
};



export const updateMDTReportStatus = async (
  reportId: number | string,
  newStatus: MDTReportStatus
) => {
  const response = await api.patch(
    `/mdtreport/${reportId}/status`,
    { status: newStatus }
  );
  return response.data;
};

export interface UpdateMDTReportContextPayload {
  context: string | Record<string, any>;
}

export interface UpdateMDTReportContextResponse {
  id: number;
  status: MDTReportStatus;
  message: string;
}

export const updateMDTReportContext = async (
  reportId: number | string,
  payload: UpdateMDTReportContextPayload
): Promise<UpdateMDTReportContextResponse> => {
  const response = await api.patch(
    `/mdtreport/${reportId}/context`,
    payload
  );

  return response.data;
};


export const deleteMDTReport = async (reportId: number) => {

  const response = await api.delete(
    `/mdtreport/${reportId}`,
  );

  return response.data;
};




